import { render, staticRenderFns } from "./InspectionDocumentEditorView.vue?vue&type=template&id=71bd83ce&scoped=true&"
import script from "./InspectionDocumentEditorView.vue?vue&type=script&lang=js&"
export * from "./InspectionDocumentEditorView.vue?vue&type=script&lang=js&"
import style0 from "./InspectionDocumentEditorView.vue?vue&type=style&index=0&id=71bd83ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bd83ce",
  null
  
)

export default component.exports